// Вспомогательные функции для форматирования вывода.

/**
 * Отформатировать цену
 * 
 * @param value Сумма
 * @returns Строка для вывода
 */
function formatMoney( value: number ): string
{
	return value.toFixed( 0 ).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ' );
}

/**
 * Извлекает количество комнат из типа комнат.
 * 
 * @param roomType Тип комнат.
 * @returns Количество комнат.
 */
function extractRoomTypeNum( roomType: string ): string
{
	return roomType.replace( /\s.+/, '' );
}

/**
 * Извлекает текст типа из типа комнат.
 * 
 * @param roomType Тип комнат.
 * @returns Текст типа комнаты.
 */
function extractRoomTypeText( roomType: string ): string
{
	return roomType.replace( /^[^(]+/, '' ) || 'комн.';
}

/**
 * Module.
 */
export {
	formatMoney,
	extractRoomTypeNum,
	extractRoomTypeText,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/utils/FormatHelpers.ts